import { useState, useEffect, Suspense, lazy } from "react";
const LeadFormModal = lazy(() => import("./LeadFormModal"));

const LeadForm = () => {
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const isPopupShown = sessionStorage.getItem("popupShown");

    if (!isPopupShown) {
      const timer = setTimeout(() => {
        setShowForm(true);
        sessionStorage.setItem("popupShown", "true");
      }, 30000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleCloseForm = () => {
    setShowForm(false);
  };

  if (!showForm) return null;

  return (
    <>
      {showForm && (
        <Suspense fallback={null}>
          <LeadFormModal
            showForm={showForm}
            handleCloseForm={handleCloseForm}
          />
        </Suspense>
      )}
    </>
  );
};

export default LeadForm;
